import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, of } from 'rxjs';

import { billAccountsLoadFromExpAPI } from '@amfam/billing/billaccount/data-access/lib/+state/billaccountExp.actions';
import { AnalyticsFacade } from '@amfam/shared/analytics/lib/+state/analytics.facade';

import { PaymentMethodExpService } from '../../services/payment-method-exp.service';
import {
  addExpPaymentMethodsFailure,
  addExpPaymentMethodsSuccess,
  addExpPaymentMethods as PaymentMethodExpActionsAddExpPaymentMethods
} from './payment-method-exp.actions';

export const addExpPaymentMethods = createEffect(
  (
    actions$ = inject(Actions),
    store = inject(Store),
    paymentMethodExpService = inject(PaymentMethodExpService),
    analyticsFacade = inject(AnalyticsFacade)
  ) => {
    return actions$.pipe(
      ofType(PaymentMethodExpActionsAddExpPaymentMethods),
      mergeMap(action =>
        paymentMethodExpService
          .addExpApiPaymentMethod({
            policyNumber: action.payload.policyNumber,
            newPaymentMethod: action.payload.newPaymentMethod,
            customer_mdm: action.payload.customer_mdm,
            pniName: action.payload.pniName
          })
          .pipe(
            map(response => {
              store.dispatch(billAccountsLoadFromExpAPI());
              analyticsFacade.trackEvent({
                event: 'add_payment_method_success',
                policyNumber: action.payload.policyNumber,
                payment_type: action.payload.newPaymentMethod.creditCard ? 'CC' : 'EFT'
              });
              return addExpPaymentMethodsSuccess(action.payload.policyNumber, response);
            }),
            catchError(error => {
              analyticsFacade.trackEvent({
                event: 'add_payment_method_error',
                policyNumber: action.payload.policyNumber,
                payment_type: action.payload.newPaymentMethod.creditCard ? 'CC' : 'EFT'
              });
              return of(
                addExpPaymentMethodsFailure({
                  policyNumber: action.payload.policyNumber,
                  error
                })
              );
            })
          )
      )
    );
  },
  { functional: true }
);
